import {
    CHANGE_EXTERNAL_ID,
    CHECK_CHANGE,
    CHECK_CUSTOMER_REQUEST,
    CHECK_SELECT_ALL, CLOSE_POPUP,
    CONFIG_REQUEST, DISABLED_BTN, ERROR_POPUP, HOVER_ALL, MOBILE_GUIDES, MOBILE_MENU, MOBILE_MENU_OPEN_ITEM,
    SAVE_REQUEST,
    SUBSCRIPTIONS_REQUEST
} from "./types";

const queryString = window.location.search.replace('+', '_____');
const urlParams = new URLSearchParams(queryString);
const email = urlParams.get('email') !== null ? urlParams.get('email').replace('_____', '+') : null;
const cis = urlParams.get('cis') !== null ? urlParams.get('cis').replace('_____', '+') : null;
const marker = urlParams.get('marker') !== null ? urlParams.get('marker').replace('_____', '+') : null;
const initialState = {
    locale: document.URL.indexOf('/ru/') !== -1 ? 'ru' : 'en',
    isMobile: (window.innerWidth <= 1024) ? true : false,
    userEmail: email !== null ? email : '',
    userMarker: marker !== null ? parseInt(marker) : 0,
    checkCustomerRequest: false,
    configRequest: false,
    subscriptionsRequest: false,
    customer: null,
    area: null,
    subscriptionsData: null,
    configData: null,
    mobileMenu: false,
    subscriptions: null,
    subscriptionChange: false,
    saveBtn: false,
    selectAllBtn: false,
    successPopup: false,
    hoverAll: false,
    mobileMenuOpenItem: '',
    errorMarker: marker !== null ? false : true,
    errorEmail: email !== null ? false : true,
    errorPopup: email !== null ? false : true,
    error: email !== null ? '' : 'not_email',
    cis: cis,
    isEmailInvalid: false,
    mobileGuides: false
}
window.document.title = document.URL.indexOf('/ru/') !== -1 ? 'Настройка рассылок' : 'Subscriptions manager';
export const appReducer = (state = initialState, action) => {
    let subscriptions = state.subscriptions
    switch (action.type) {
        case CHECK_CUSTOMER_REQUEST:
            return {
                ...state,
                customer: action.payload.customer,
                subscriptions: action.payload.customer.subscriptions,
                area: action.payload.customer.area,
                isEmailInvalid: action.payload.customer.isEmailInvalid,
                checkCustomerRequest: true,
            }
        case SUBSCRIPTIONS_REQUEST:
            return {
                ...state,
                subscriptionsRequest: true,
                subscriptionsData: action.payload
            }
        case CONFIG_REQUEST:
            return {
                ...state,
                configRequest: true,
                configData: action.payload
            }
        case CHECK_CHANGE:
            subscriptions[action.payload.index].isSubscribed = action.payload.isSubscribed
            return {
                ...state,
                subscriptions: subscriptions,
                subscriptionChange: !state.subscriptionChange,
                saveBtn: true
            }
        case CHECK_SELECT_ALL:
            let unchecked = false;
            for (let i = 0; i < subscriptions.length; i++) {
                if (subscriptions[i].isSubscribed === false) {
                    unchecked = true;
                }
            }
            for (let i = 0; i < subscriptions.length; i++) {
                subscriptions[i].isSubscribed = unchecked
            }
            return {
                ...state,
                subscriptions: subscriptions,
                subscriptionChange: !state.subscriptionChange,
                saveBtn: true,
                selectAllBtn: unchecked
            }
        case SAVE_REQUEST:
            return {
                ...state,
                saveBtn: false,
                successPopup: true
            }
        case CLOSE_POPUP:
            return {
                ...state,
                successPopup: false,
                errorPopup: false
            }
        case DISABLED_BTN:
            return {
                ...state,
                saveBtn: false
            }
        case ERROR_POPUP:
            return {
                ...state,
                errorPopup: true,
                error: action.payload
            }
        case MOBILE_MENU: {
            return {
                ...state,
                mobileMenu: action.payload
            }
        }
        case CHANGE_EXTERNAL_ID: {
            return {
                ...state,
                area: {
                    ...state.area,
                    ids: {
                        ...state.area.ids,
                        externalId: action.payload
                    }
                },
                subscriptionChange: !state.subscriptionChange,
                saveBtn: true
            }
        }
        case HOVER_ALL: {
            return {
                ...state,
                hoverAll: action.payload
            }
        }
        case MOBILE_MENU_OPEN_ITEM: {
            return {
                ...state,
                mobileMenuOpenItem: action.payload
            }
        }
        case MOBILE_GUIDES: {
            return {
                ...state,
                mobileGuides: action.payload
            }
        }
        default:
            return state
    }
}